module.exports = __webpack_public_path__ + "static/user-story-e291bc91d20e43bad118e229167f05f9.png";